<template>
 <div class="login row row_jsc row_ac">
		<div class="login_box">
			<h1>MINTIT-BOS</h1>
			<div class="txt">
				<p>BOS 시스템에 오신것을 환영합니다.</p>
				<p v-if="!hasAutoLoginToken">회원 계정으로 로그인해 주세요</p>
        <p v-else>인증번호를 입력해 주세요</p>
			</div>
			<form v-if="!hasAutoLoginToken" action="">
				<fieldset>
					<div class="login_input">
						<div class="id row">
							<label for=""></label>
							<input type="text" name="아이디" @keyup.enter="login" v-model="params.userId" v-validate="'required'" placeholder="아이디">
							<div class="lo_validation top_03" v-if="errors.has('아이디')">
							  <div class="lo_tri"></div>
								<span>{{ errors.first('아이디') }}</span>
							</div>
            </div>
						<div class="pw row">
							<label for=""></label>
							<input type="password" name="비밀번호"  placeholder="Enter your password" @keyup.enter="login" v-model="params.pwd" v-validate="'required'">
							<div class="lo_validation top_02" v-if="errors.has('비밀번호')">
							  <div class="lo_tri"></div>
								<span>{{ errors.first('비밀번호') }}</span>
							</div>
						</div>
					</div>
				</fieldset>
			</form>
			<!-- 인증요청 -->
				<fieldset v-if="params.publicYn">
					<div class="confirm" >
						<div class="number row">
							<label ></label>
							<input type="text" v-model="params.authNumber" placeholder="인증번호를 입력해 주세요">
							<timeCounter ref="commonTimeCounter" :startTime="authNumberTime" />
						</div>
						<div class="con_btn">
							<button type="button" @click="getAuthNumber">인증번호 요청</button>
						</div>
					</div>
				</fieldset>
      <DxCheckBox v-if="!hasAutoLoginToken" text="자동 로그인" class="wp100 mar_t20" :value="params.isAutoLoginActive" @valueChanged="chngAutoLoginCheck" />
			<button type="button" class="login_btn" @click="login">로그인</button>
      <button type="button" class="login_btn" @click="initPassword">비밀번호 초기화</button>
		</div>
    <initPasswordPopup />
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import TimeCounter from '@/components/TimeCounter'
import Utils from '@/modules/utils'
import InitPasswordPopup from './common/InitPasswordPopup.vue'
import '@/assets/css/login.css'

import { DxCheckBox } from 'devextreme-vue/check-box'

export default {
  name: 'Login',
  components: { TimeCounter, InitPasswordPopup, DxCheckBox },
  data: () => ({
    AppConfig: AppConfig,
    params: {
      userId: '',
      pwd: '',
      authNumber: '',
      isAutoLoginActive: false,
      isMobile: true,
      publicYn: false,
      autoLoginToken: ''
    },
    authNumberTime: 180,
    loginShow: true
  }),
  computed: {
    mainClass () {
      return 'about-minti-0' + Utils.generateRandom(1, 2)
    },
    hasAutoLoginToken () {
      if (!window || !window.localStorage) return false

      const autoLoginToken = window.localStorage.getItem('autoLoginToken')

      if (!autoLoginToken) return false

      return true
    },
    userId () {
      return window.$store.getters['Login/getUserId']
    }
  },
  created () {
    if (this.userId) {
      this.$router.push('/home')
    }
  },
  mounted () {
    this.loginShow = AppConfig.LOGIN_SHOW
    if (window && window.localStorage) {
      const autoLoginToken = window.localStorage.getItem('autoLoginToken')
      if (autoLoginToken) {
        this.loginByToken(autoLoginToken)
        // this.params.isAutoLoginActive = true
      }
    }
  },
  methods: {
    chngAutoLoginCheck (e) {
      const { value } = e
      this.params = { ...this.params, isAutoLoginActive: value }
    },
    login () {
      this.isValidateParam()
        .then((success) => {
          if (!success) { return }
          window.$store
            .dispatch('Login/login', this.params)
            .then((result) => {
              this.loginReactionSucc(result)
            })
            .catch(e => {
              this.loginReactionFail(e)
            })
        })
    },
    loginByToken (autoLoginToken) {
      window.$store
        .dispatch('Login/loginByToken', autoLoginToken)
        .then((result) => {
          this.loginReactionSucc(result)
        })
        .catch(e => {
          this.loginReactionFail(e)
        })
    },
    async loginReactionSucc (result) {
      const { authList } = result
      const isCheckPwChngDt = [...authList].includes('ATM01')
      if (!isCheckPwChngDt && result.chngDtYn) {
        if (result.overChngDtYn) {
          this.$Alert.alert('비밀번호 변경일이 지났습니다. </br>하단에 초기화 기능을 이용해주세요.')
          return
        }
        await this.$Alert.confirm(`비밀번호 변경일이 <span style="color:#FF2424;font-weight:bold;">${result.limitChngDt}</span>일 남았습니다. </br>비밀번호를 변경하시겠습니까?`)
          .then((confirm) => {
            if (confirm === 'close') { this.$router.push({name: 'home'}) } // x 버튼 아무것도 안함
            if (confirm) {
              this.$router.push({name: 'password'})
            } else {
              this.$router.push({name: 'home'})
            }
          })
      } else {
        if (result.initPwdChngYn) {
          this.$router.push({name: 'home'})
        } else {
          this.$router.push({name: 'password'})
        }
      }
    },
    loginReactionFail (e) {
      console.log('>>>> > file: Login.vue > line 146 > loginReactionFail > e', e)
      if (e.result === undefined) {
        this.$Alert.alert(e.data.result.message)
        return
      }
      if (e.result.status === AppConfig.LOGIN_FAIL) {
        this.$Alert.alert('로그인에 실패하였습니다.(' + e.result.result.loginFailCount + '회)<br/>아이디,비밀번호를 확인하여 주십시오.')
      } else if (e.result.status === AppConfig.NO_ID) {
        this.$Alert.alert('등록되지 않은 로그인ID입니다.')
      } else if (e.result.status === AppConfig.NOT_EXIST_PHONE) {
        this.$Alert.alert('등록된 휴대전화번호가 없습니다.<br/>휴대전화번호를 입력하여 주십시오.')
      } else if (e.result.status === AppConfig.ACCOUNT_LOCKOUT) {
        this.$Alert.alert('5회 이상 로그인에 실패하여<br/><span style="color:#FF2424;font-weight:bold;">계정상태</span>가 <span style="color:#FF2424;font-weight:bold;">잠금</span> 상태로 변경되었습니다.<br/>하단 비밀번호 초기화 기능을 이용하시거나<br/>관리자에게 문의 하십시오.')
      } else if (e.result.status === AppConfig.AUTH_NUMBER_FAIL) {
        this.$Alert.alert('인증번호 인증에 실패하였습니다.')
      } else if (e.result.status === AppConfig.MOBILE_AUTOLOGIN_FAIL) {
        this.$Alert.alert('자동 로그인이 만료되었습니다.')
        window.localStorage.removeItem('autoLoginToken')
      } else if (e.result.status === AppConfig.AUTH_NUMBER_NULL) {
        this.getAuthNumber()
      }
    },
    isValidateParam () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then((validRes) => {
            let _validRes = validRes
            if (this.hasAutoLoginToken) {
              _validRes = true
            }
            resolve(_validRes)
          })
          .catch(e => reject(e))
      })
    },
    getAuthNumber () {
      this.isValidateParam()
        .then((success) => {
          if (!success) { return }
          // 인증번호 전송 요청

          if (this.hasAutoLoginToken) {
            Object.assign(this.params, {
              userUuid: window.localStorage.getItem('autoLoginToken'),
              isAutoLogin: true
            })
          }

          Vue.httpClient
            .post('/app/login/authnumber', this.params)
            .then((response) => {
              if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
                if (response.data.result !== undefined) {
                  Vue.Alert.alert(response.data.result)
                // this.params.authNumber = response.data.result;
                } else {
                  Vue.Alert.alert('인증번호를 전송하였습니다.<br/>인증번호 입력 후 로그인을 시도해 주십시오.')
                }
                this.$refs.commonTimeCounter.startCounter()
              }
            })
            .catch(e => {
              if (e.result.status === AppConfig.NOT_EXIST_PHONE) {
                Vue.Alert.alert('등록된 휴대전화번호가 없습니다.<br/>휴대전화번호를 입력하여 주십시오.')
              } else if (e.result.status === AppConfig.LOGIN_FAIL) {
                Vue.Alert.alert('인증번호 전송에 실패하였습니다.<br/>아이디,비밀번호를 확인하여 주십시오.')
              }
            })
        })
    },
    initPassword () {
      this.$modal.show('initPasswordPopup')
    },
    addUser () {
      this.$modal.show('userManagePopup', {isUpdate: false, startVue: 'login'})
    },
    selectPopupList () { // 팝업리스트 조회
      let params = {
        isSelectPopList: 'Y'
      }
      Vue.httpClient
        .post('/board/list', params)
        .then(response => {
          if (response.data.result) {
            let data = response.data.result.list
            this.openBoardPopup(data)
          }
        })
    },
    openBoardPopup (data) {
      for (let i in data) {
        let routeData1 = this.$router.resolve({name: 'BoardPopup', params: {bulletinBoardNo: data[i].bulletinBoardNo}})
        Utils.openPopup(routeData1, 'boardPopup' + i, 600, 500, 'N', i * 500)
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Login.vue